import { lazy } from "react";
import { format_routes } from '@/utils/tools';

const LogisticsMain = lazy(() => import("../pages/logistics/main"));
const LogisticsAdd = lazy(() => import("../pages/logistics/add"));
const LogisticsCreate = lazy(() => import("../pages/logistics/create"));
const LogisticsDetail = lazy(() => import("../pages/logistics/detail"));
const LogisticsList = lazy(() => import("../pages/logistics/list"));

export const LogisticsRouters = [
  {
    path: "/Logistics/main",
    element: <LogisticsMain />,
  },
  {
    path: "/Logistics/add",
    element: <LogisticsAdd />,
  },
  {
    path: "/Logistics/create/:unCode",
    element: <LogisticsCreate />,
  },
  {
    path: "/Logistics/detail/:sub_un_code/:business_number/:equipment_code",
    element: <LogisticsDetail />,
  },
  {
    path: "/Logistics/list",
    element: <LogisticsList />,
  },
];


export const format_logistics_router_routes = format_routes(LogisticsRouters);
